import { action, computed, makeObservable, observable } from 'mobx'
import { Extent } from 'ol/extent'
import { FormBuilderCellDefinition } from '../FormBuilderCore/cells/FormBuilderCellDefinition'
import { StandaloneCellManager } from '../FormBuilderInterop/Runtimes/Standalone'
import { IDocumentRenderer } from './IDocumentRenderer'
import {
	BoundingBox,
	OcrLabelData,
	OcrPage,
	OcrWorkflowTaskState,
} from './OcrTypes'

export type Word = {
	text: string
	boundingBox: number[]
}

export type FieldDefinition = Readonly<{
	key: string
	type: FieldType
	label: string
	color: string
	confidenceIntervals: [number, number]
}>

export type FieldInstance = {
	key: string
	text?: string
	value?: string | number | Date
	confidence?: number
	boundingBox?: number[]
}

export enum FieldType {
	StringType = 'string',
	NumberType = 'number',
	DateType = 'date',
	TimeType = 'time',
	IntegerType = 'integer',
	SelectionMarkType = 'selectionMark',
}

export type MapControl = Partial<{
	zoomIn: () => void
	zoomOut: () => void
	panUp: () => void
	panDown: () => void
	panLeft: () => void
	panRight: () => void
	fitToPage: (pageNumber?: number, clearBoxes?: boolean) => void
	// showBoundingBox: (fieldName?: string, fitToField?: boolean) => void
	showBoundingBox: (boundingBox?: BoundingBox, pageNumber?: number, fitToField?: boolean) => void
}>

type ResultsControl = Partial<{
	nextField: () => void
	nextLowConfidenceField: () => void
	previousField: () => void
	submit: () => void
}>

export type ResultField = {
	definition: FormBuilderCellDefinition
	boundingBox?: BoundingBox
	value?: unknown
	// pageNumber: number //TODO is this a repeat? already in field definition
}

export interface IDocumentReviewController {
	workflowInstanceId: number

	selectedBoundingBox?: BoundingBox
	mapControl: MapControl
	resultsControl: ResultsControl
	formHost: StandaloneCellManager

	ocrExtent?: Extent

	readonly documentRenderer?: IDocumentRenderer
	setDocument: (documentRenderer?: IDocumentRenderer) => void

	fields: Record<string, OcrLabelData>

	document: Blob
	invoiceResults: OcrWorkflowTaskState

	currentPageNumber: number

	controllerReady: boolean
}

export class DocumentReviewController implements IDocumentReviewController {
	/**
	 *
	 */
	constructor(
		workflowInstanceId: number,
		formHost: StandaloneCellManager,
		document: Blob,
		invoiceResult: OcrWorkflowTaskState,
		fields: Record<string, OcrLabelData>,
	) {
		makeObservable<
			DocumentReviewController,
			| '_document'
			| '_workflowInstanceId'
			| '_documentRenderer'
			| '_currentPageReadResults'
			| '_selectedFieldName'
			| '_controllerReady'
			| 'currentPageNumber'
			| 'mapControl'
		>(this, {
			workflowInstanceId: computed,
			document: computed,
			_document: observable,
			invoiceResults: computed,
			_selectedFieldName: observable,
			selectedFieldName: computed,
			setDocument: action,
			documentRenderer: computed,
			_workflowInstanceId: observable,
			_documentRenderer: observable,
			mapControl: observable,
			resultsControl: observable,
			imageExtent: observable,
			ocrExtent: computed,
			_currentPageReadResults: computed,
			currentPageNumber: observable,
			_controllerReady: observable,
			controllerReady: computed
		})

		this._workflowInstanceId = workflowInstanceId
		this.formHost = formHost
		console.log('setting invoice result to', invoiceResult)
		this._invoiceResult = invoiceResult
		this._document = document
		this._fields = fields

		// const interval = setInterval(() => {
		// 	console.log('running interval', this.documentRenderer !== undefined)
		// 	if (this.documentRenderer !== undefined) {
		// 		clearInterval(interval)
		// 		this._controllerReady = true
		// 	}

		// }, 1000)
	}

	private _controllerReady = true

	get controllerReady(): boolean {
		return this._controllerReady
	}

	currentPageNumber = 0

	formHost: StandaloneCellManager

	get workflowInstanceId(): number {
		return this._workflowInstanceId
	}

	get document(): Blob {
		return this._document
	}

	private _document: Blob

	get invoiceResults(): OcrWorkflowTaskState {
		return this._invoiceResult
	}

	private _invoiceResult: OcrWorkflowTaskState

	get fields(): Record<string, OcrLabelData> {
		return this._fields
	}

	private _fields: Record<string, OcrLabelData>

	private _selectedFieldName?: string

	get selectedFieldName(): string | undefined {
		return this._selectedFieldName
	}

	set selectedFieldName(value: string | undefined) {
this._selectedFieldName = value
	}

	setDocument(documentRenderer?: IDocumentRenderer) {
		this._documentRenderer = documentRenderer
	}

	get documentRenderer(): IDocumentRenderer | undefined {
		return this._documentRenderer
	}

	private _workflowInstanceId: number

	private _documentRenderer?: IDocumentRenderer | undefined

	mapControl: MapControl = {}

	resultsControl: ResultsControl = {}

	imageExtent?: Extent | undefined

	get ocrExtent(): Extent | undefined {
		console.log('current page read results', this._currentPageReadResults)
		if (this._currentPageReadResults === undefined) return undefined

		return [
			0,
			0,
			this._currentPageReadResults.width,
			this._currentPageReadResults.height,
		]
	}

	private get _currentPageReadResults(): OcrPage | undefined {
		if (this.documentRenderer === undefined) return undefined

		console.log(this._invoiceResult.results.pages)
		console.log(this.currentPageNumber)

		return this._invoiceResult.results.pages[this.currentPageNumber]
	}
}
